export const reconcilePermissionOverrides = (overrides, permissionKeys) => {
    if (!Array.isArray(permissionKeys)) return { ...(overrides || {}) };

    const basePermissions = new Set(permissionKeys);
    return Object.entries(overrides || {}).reduce((result, [key, value]) => {
        if (basePermissions.has(key) !== value) result[key] = value;
        return result;
    }, {});
};

export const formatMemberLastActive = (value) => {
    const date = value ? new Date(value) : null;
    if (!date || Number.isNaN(date.getTime()) || date.getFullYear() <= 2000) return "—";

    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
};

export const memberRoleValue = (member) => {
    if (member?.team_role === "custom" && member?.access_role?.id) {
        return "custom:" + member.access_role.id;
    }
    return member?.team_role || "regular";
};

export const buildMemberAccessPayload = (roleValue, overrides, accessLockVersion) => {
    if (roleValue.startsWith("custom:")) {
        return {
            role_type: "custom",
            access_role_id: roleValue.slice("custom:".length),
            permission_overrides: overrides,
            access_lock_version: accessLockVersion,
        };
    }

    return {
        role_type: roleValue,
        access_role_id: null,
        permission_overrides: {},
        access_lock_version: accessLockVersion,
    };
};

export const overrideMode = (overrides, key) => {
    if (!Object.prototype.hasOwnProperty.call(overrides, key)) return "default";
    return overrides[key] === true ? "allow" : "deny";
};

export const applyOverrideMode = (overrides, key, mode) => {
    const next = { ...overrides };
    if (mode === "default") delete next[key];
    else next[key] = mode === "allow";
    return next;
};
